const SESION_KEY = 'datosCalificador';
const TABLA_KEY = 'tablaSesionesCalificacion';
const BROWSER_KEY = 'browserIdCalificacion';

function obtenerAliasTelefono() {
  try {
    const nav = navigator || {};
    const platform = nav.userAgentData?.platform || nav.platform || '';
    const vendor = nav.vendor || '';
    const userAgent = nav.userAgent || '';
    const partes = [platform, vendor, userAgent].filter(Boolean);
    return partes.join(' - ') || 'Dispositivo';
  } catch (e) {
    return 'Dispositivo';
  }
}

function generarIdNavegador() {
  try {
    const { crypto } = window;
    if (crypto?.randomUUID) return crypto.randomUUID();
  } catch (e) {
    // ignore
  }
  return `nav-${Math.random().toString(36).slice(2)}-${Date.now()}`;
}

export function obtenerIdNavegador() {
  let id = localStorage.getItem(BROWSER_KEY);
  if (!id) {
    id = generarIdNavegador();
    localStorage.setItem(BROWSER_KEY, id);
  }
  return id;
}

export function obtenerDatosSesion() {
  const raw = localStorage.getItem(SESION_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw);
  } catch (e) {
    return null;
  }
}

export function guardarDatosSesion({ telefono, nombre }) {
  const datos = {
    aliasTelefono: obtenerAliasTelefono(),
    telefono: telefono?.trim() || '',
    nombre: nombre?.trim() || '',
  };
  localStorage.setItem(SESION_KEY, JSON.stringify(datos));
  if (datos.telefono) {
    localStorage.setItem('idUsuario', datos.telefono);
    localStorage.setItem('validado', '1');
  }
  return datos;
}

export function obtenerTablaSesiones() {
  const raw = localStorage.getItem(TABLA_KEY);
  if (!raw) return [];
  try {
    return JSON.parse(raw);
  } catch (e) {
    return [];
  }
}

export function registrarSesionEnTabla(restauranteId) {
  const datos = obtenerDatosSesion();
  if (!datos) return;
  const tabla = obtenerTablaSesiones();
  const registro = {
    restauranteId: Number(restauranteId),
    telefono: datos.telefono,
    aliasTelefono: datos.aliasTelefono,
    nombre: datos.nombre,
    navegadorId: obtenerIdNavegador(),
    fecha: new Date().toISOString(),
  };
  tabla.push(registro);
  localStorage.setItem(TABLA_KEY, JSON.stringify(tabla));
}

export function existeRegistroParaRestaurante(restauranteId) {
  const navegadorId = obtenerIdNavegador();
  const datos = obtenerDatosSesion();
  const telefono = datos?.telefono;
  return obtenerTablaSesiones().some((item) => {
    const mismoRestaurante = Number(item.restauranteId) === Number(restauranteId);
    const mismoTelefono = telefono && item.telefono === telefono;
    const mismoNavegador = item.navegadorId === navegadorId;
    return mismoRestaurante && (mismoTelefono || mismoNavegador);
  });
}
